import React, { useState } from 'react';
import styles from './Header.module.css';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import DownloadTheApplication from '../downloadTheApplication/DownloadTheApplication';
import { StarSvg, ProfileSvg, ExitSvg, EventSvg, MenuSvg, CloseSvg } from '../../img/Image';
import { useContext } from 'react';
import { UserContext } from '../../context/UserContext';
import { useApi } from '../../utils/useApi';
import { createAuthApi } from './api';
import { useScreenSize } from '../auxiliaryFunctions';

const Header = () => {
    const { isMobile } = useScreenSize();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [userInfo, setUserInfo] = useContext(UserContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { customFetch } = useApi();
    const authApi = createAuthApi(customFetch);

    const handleLogout = async () => {
        try {
            const result = await authApi.logOut();
            if (result) {
                setUserInfo({ token: false, userId: "" });
                localStorage.setItem("UserToken", JSON.stringify({ token: false, userId: "" }));
                navigate('/login');
                setIsMenuOpen(false);
            }
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    // Функция для определения текущего экрана
    const getCurrentScreenName = () => {
        const path = location.pathname;
        if (path === '/') return 'Ближайшие события';
        if (path === '/my-applications') return 'Мои заявки';
        if (path === '/edit-profile') return 'Профиль';
        return 'Заявка на мероприятие';
    };

    return (
        <header className={styles.header}>
            <nav className={styles.navContainer}>
                <div className={styles.leftBlock}>
                    <Link to="/" className={styles.parallelogramLink}>
                        <div className={styles.parallelogram}>
                            <span>БЛИЖАЙШИЕ СОБЫТИЯ</span>
                        </div>
                    </Link>
                </div>

                {isMobile ? (
                    <>
                        {/* Кнопка меню и название текущего экрана */}
                        <div className={styles.mobileHeader}>
                            <span className={styles.currentScreen}>{getCurrentScreenName()}</span>
                            <button
                                className={styles.menuButton}
                                onClick={toggleMenu}
                                aria-label="Открыть меню"
                            >
                                <MenuSvg />
                            </button>
                        </div>

                        {/* Выдвижное меню */}
                        <div className={`${styles.mobileMenu} ${isMenuOpen ? styles.mobileMenuOpen : ''}`}>
                            {/* Кнопка закрытия на самом экране меню */}
                            <button
                                className={styles.closeButtonOnMenu}
                                onClick={closeMenu}
                                aria-label="Закрыть меню"
                            >
                                <CloseSvg />
                            </button>
                            
                            <div className={styles.mobileMenuContent}>
                                <Link
                                    to="/"
                                    className={styles.mobileNavItem}
                                    onClick={closeMenu}
                                >
                                    <EventSvg className={styles.navIcon} />
                                    <span>Ближайшие события</span>
                                </Link>

                                <Link
                                    to="/my-applications"
                                    className={styles.mobileNavItem}
                                    onClick={closeMenu}
                                >
                                    <StarSvg className={styles.navIcon} />
                                    <span>Мои заявки</span>
                                </Link>

                                <Link
                                    to="/edit-profile"
                                    className={styles.mobileNavItem}
                                    onClick={closeMenu}
                                >
                                    <ProfileSvg className={styles.navIcon} />
                                    <span>Профиль</span>
                                </Link>

                                {/* <DownloadTheApplication
                                    forHeader={true}
                                    compact={true}
                                    isMobileVersion={true}
                                    onClick={closeMenu}
                                /> */}

                                <div
                                    className={styles.mobileNavItem}
                                    onClick={handleLogout}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <ExitSvg className={styles.navIcon} />
                                    <span>Выйти</span>
                                </div>
                            </div>
                        </div>

                        {/* Затемнение фона при открытом меню */}
                        {isMenuOpen && (
                            <div
                                className={styles.overlay}
                                onClick={closeMenu}
                            />
                        )}
                    </>
                ) : (
                    /* Десктопная версия (без изменений) */
                    <div className={styles.centerContent}>
                        <Link to="/my-applications" className={styles.navItem}>
                            <StarSvg className={styles.navIcon} />
                            <span>Мои заявки</span>
                        </Link>

                        <Link to="/edit-profile" className={styles.navItem}>
                            <ProfileSvg className={styles.navIcon} />
                            <span>Профиль</span>
                        </Link>

                        {/* <div className={styles.navItem}>
                            <DownloadTheApplication forHeader={true} compact={true} isMobileVersion={false} />
                        </div> */}

                        <div className={styles.navItem} onClick={handleLogout} style={{ cursor: 'pointer' }} >
                            <ExitSvg className={styles.navIcon} />
                            <span>Выйти</span>
                        </div>
                    </div>
                )}
            </nav>
        </header>
    );
};

export default Header;